/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_Btn_EinvoiceInputs */

const tr_landing_telegram_mock_btn_einvoice = /** @type {(inputs: Landing_Telegram_Mock_Btn_EinvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Fatura`)
};

const en_landing_telegram_mock_btn_einvoice = /** @type {(inputs: Landing_Telegram_Mock_Btn_EinvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-invoice`)
};

const de_landing_telegram_mock_btn_einvoice = /** @type {(inputs: Landing_Telegram_Mock_Btn_EinvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Fatura`)
};

const ru_landing_telegram_mock_btn_einvoice = /** @type {(inputs: Landing_Telegram_Mock_Btn_EinvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-fatura`)
};

/**
* | output |
* | --- |
* | "E-invoice" |
*
* @param {Landing_Telegram_Mock_Btn_EinvoiceInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_btn_einvoice = /** @type {((inputs?: Landing_Telegram_Mock_Btn_EinvoiceInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_Btn_EinvoiceInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_btn_einvoice(inputs)
	if (locale === "de") return de_landing_telegram_mock_btn_einvoice(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_btn_einvoice(inputs)
	return tr_landing_telegram_mock_btn_einvoice(inputs)
});